import {
    RESET_LOAD_PROGRESS_SETTINGS,
    SET_LOAD_PROGRESS_SETTINGS,
    TOGGLE_LOADING,
    TOGGLE_LOAD_PROGRESS_BAR
} from '../actions/actionTypes';

const initialState = {
    isLoading:              false,
    loadProgressBarLoading: false,
    settings:               {
        currentValue: 0,
        maxValue:     100,
        label:        ''
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case RESET_LOAD_PROGRESS_SETTINGS:
            return {
                ...state,
                settings: {
                    currentValue: 0,
                    maxValue:     100,
                    label:        ''
                }
            };
        case SET_LOAD_PROGRESS_SETTINGS:
            return {
                ...state,
                settings: {...action.payload}
            };
        case TOGGLE_LOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        case TOGGLE_LOAD_PROGRESS_BAR:
            return {
                ...state,
                loadProgressBarLoading: action.payload
            };
        default:
            return state;
    }
};
